// extracted by mini-css-extract-plugin
export default {"menuWrap":"DropDownMenu_menuWrap__IfnBY"};